/**
 * @module: 汇总
 * @author: Yawei Wang
 * @date: 2019-06-03 13:51:28
 */
import * as ajax from './ajax';
import * as cookie from './cookie';
import * as custom from './custom'; // import * as edit from './edit'

import * as html from './html';
import * as rule from './rule';
import * as user from './user';
import * as utils from './utils';
import * as download from './download';
import * as range from './range';
import * as window from './window';
import * as iframe from './iframe';
import * as wkxUnread from './wkx_unread';
import * as ad from './ad';
export { ajax, cookie, custom // edit,
, html, rule, user, utils, download, range, window, iframe, wkxUnread, ad };
export default {
  ajax: ajax,
  cookie: cookie,
  custom: custom,
  // edit,
  html: html,
  rule: rule,
  user: user,
  utils: utils,
  download: download,
  range: range,
  window: window,
  iframe: iframe,
  wkxUnread: wkxUnread,
  ad: ad
};